<template>
    <transition name="fade">
        <div class="full-modal">
            <div class="full-modal-body">
                <h2 class="text-center">{{ $t("request_offer") }}</h2>
                <div v-if="errors.message" class="alert alert-danger">
                    {{ errors.message }}
                    <ul>
                        <template v-for="(messages, key) in errors.errors">
                            <li v-for="message in messages">
                                {{ message }}
                            </li>
                        </template>
                    </ul>
                </div>
                <form class="form" @submit.prevent="onSubmit(2)">
                    <div class="form-group">
                        <label
                            >{{ $t("first_name") }}:
                            <input
                                v-model="contact.first_name"
                                required
                                class="form-control"
                                type="text"
                                :class="{
                                    'is-invalid': errors.errors.first_name,
                                }"
                        /></label>
                        <label
                            >{{ $t("last_name") }}:
                            <input
                                v-model="contact.last_name"
                                required
                                class="form-control"
                                type="text"
                                :class="{
                                    'is-invalid': errors.errors.last_name,
                                }"
                        /></label>
                    </div>
                    <div class="form-group">
                        <label
                            >{{ $t("phone") }}:
                            <input
                                v-model="contact.phone"
                                required
                                class="form-control"
                                type="phone"
                                :class="{ 'is-invalid': errors.errors.phone }"
                        /></label>
                        <label
                            >{{ $t("email") }}:
                            <input
                                v-model="contact.email"
                                required
                                class="form-control"
                                type="email"
                                :class="{ 'is-invalid': errors.errors.email }"
                        /></label>
                    </div>
                    <div class="form-check">
                        <input
                            id="sendEmailPrivacyConsent"
                            v-model="consents.privacy"
                            required
                            class="form-check-input"
                            type="checkbox"
                            :class="{
                                'is-invalid': errors.errors.privacy,
                            }"
                        />
                        <label
                            for="sendEmailPrivacyConsent"
                            class="form-check-label"
                        >
                            {{ $t("privacy_consent") }}
                            <a :href="privacyLink">{{
                                $t("privacy_policy")
                            }}</a>
                        </label>
                    </div>
                    <div class="form-check">
                        <input
                            id="sendEmailMarketingConsent"
                            v-model="consents.marketing"
                            class="form-check-input"
                            type="checkbox"
                            :class="{
                                'is-invalid': errors.errors.marketing,
                            }"
                        />
                        <label
                            for="sendEmailMarketingConsent"
                            class="form-check-label"
                        >
                            {{ $t("marketing_consent") }}
                        </label>
                    </div>
                    <div class="buttons mt-3">
                        <button type="submit" class="btn btn-success">
                            {{ $t("send") }}
                        </button>
                        <button
                            @click="onClose()"
                            type="button"
                            class="btn btn-danger"
                        >
                            {{ $t("close") }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </transition>
</template>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.35s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

<script>
import BaseModalContact from "./BaseModalContact";
import OfferMixin from "../mixins/Offer";

export default {
    extends: BaseModalContact,
    mixins: [OfferMixin],

    inject: ["locale"],

    data: function () {
        return {
            contact: {
                first_name: null,
                last_name: null,
                phone: null,
                email: null,
                type: 1, // Prospect
            },
            errors: {
                errors: {},
                message: null,
            },
            consents: {
                privacy: false,
                marketing: false,
            },
            isOfferRequest: true,
        };
    },

    methods: {
        onSave(data, type) {
            this.$showSpinner();
            this.createOffer({
                configuration_id: data.id,
                privacy_consent: this.consents.privacy,
                marketing_consent: this.consents.marketing,
                locale: this.locale,
            })
                .then((resp) => {
                    this.$hideSpinner();
                    this.$router.push({
                        name: "configuration",
                        params: { id: data.id },
                        query: {
                            thankyou: type,
                            locale: this.locale,
                        },
                    });
                })
                .catch((error) => {
                    this.$hideSpinner();
                    if (error.response && error.response.status == 422) {
                        this.errors = error.response.data;
                    } else {
                        this.errors.message = this.$t("unexpected_error");
                        this.errors.errors = {};
                    }
                });
        },
    },
};
</script>
